<template>
  <div class="box" v-bind:style="{backgroundImage:gradColor}" style="min-height:100%;">
          <article class="media has-text-white">
            <div class="media-left">
              <figure class="image">
                <b-icon class="is-pulled-right" size="is-large"  pack="fas" :icon="showProperty"></b-icon>
              </figure>
            </div>
            <div class="media-content">
              <div class="content">
                <p>
                  <span class="is-size-5 has-text-weight-semibold has-text-white is-capitalized">{{property}}</span>
                  <br>
                     <span class="is-size-3 has-text-weight-semibold">{{ value }}</span>
                     <span class="is-size-4 ">{{ location }}</span>
                </p>
              </div>
            </div>
          </article>
        </div>
</template>

<script>
export default {
props:{
    icon:String,
    property:String,
    value:Number,
    firstColor:String,
    secondColor:String,
    location:String
   
},
data(){
    return{
        showProperty:null,
    }
},
created(){
    this.showProperty = `fas fa-${this.icon}`
},
computed:{
    gradColor(){
        return `linear-gradient(to bottom right, ${this.firstColor}, ${this.secondColor})`;
    }
}
}
</script>



